import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    completeness: {
        defaultMessage: 'Completeness',
        id: 'iaso.completeness.title',
    },
    formsTitle: {
        defaultMessage: 'Forms',
        id: 'iaso.forms.title',
    },
    january: {
        defaultMessage: 'January',
        id: 'iaso.label.months.january',
    },
    february: {
        defaultMessage: 'February',
        id: 'iaso.label.months.february',
    },
    march: {
        defaultMessage: 'March',
        id: 'iaso.label.months.march',
    },
    april: {
        defaultMessage: 'April',
        id: 'iaso.label.months.april',
    },
    may: {
        defaultMessage: 'May',
        id: 'iaso.label.months.may',
    },
    june: {
        defaultMessage: 'June',
        id: 'iaso.label.months.june',
    },
    july: {
        defaultMessage: 'July',
        id: 'iaso.label.months.july',
    },
    august: {
        defaultMessage: 'August',
        id: 'iaso.label.months.august',
    },
    september: {
        defaultMessage: 'September',
        id: 'iaso.label.months.september',
    },
    october: {
        defaultMessage: 'October',
        id: 'iaso.label.months.october',
    },
    november: {
        defaultMessage: 'November',
        id: 'iaso.label.months.november',
    },
    december: {
        defaultMessage: 'December',
        id: 'iaso.label.months.december',
    },
    ready: {
        defaultMessage: 'Ready',
        id: 'iaso.label.instanceStatus.ready',
    },
    readyMulti: {
        defaultMessage: 'Ready',
        id: 'iaso.label.instanceStatus.readyMulti',
    },
    readySingle: {
        defaultMessage: 'Ready',
        id: 'iaso.label.instanceStatus.readySingle',
    },
    error: {
        defaultMessage: 'Error(s)',
        id: 'iaso.label.instanceStatus.error',
    },
    errorMulti: {
        defaultMessage: 'Errors',
        id: 'iaso.label.instanceStatus.errorMulti',
    },
    errorSingle: {
        defaultMessage: 'error',
        id: 'iaso.label.instanceStatus.errorSingle',
    },
    duplicatedSingle: {
        defaultMessage: 'duplicated',
        id: 'iaso.label.instanceStatus.duplicatedSingle',
    },
    exported: {
        defaultMessage: 'exported',
        id: 'iaso.label.instanceStatus.exported',
    },
    exportedMulti: {
        defaultMessage: 'Exported',
        id: 'iaso.label.instanceStatus.exportedMulti',
    },
    exportedSingle: {
        defaultMessage: 'Exported',
        id: 'iaso.label.instanceStatus.exportedSingle',
    },
    actions: {
        defaultMessage: 'Action(s)',
        id: 'iaso.label.actions',
    },
    generateDerivedInstances: {
        id: 'iaso.completeness.generateDerivedInstances',
        defaultMessage: 'Generate derived instances',
    },
    periodType: {
        id: 'iaso.label.periodType',
        defaultMessage: 'Period type',
    },
    year: {
        id: 'iaso.label.periodType.year',
        defaultMessage: 'Year',
    },
    quarter: {
        id: 'iaso.label.periodType.quarter',
        defaultMessage: 'Quarter',
    },
    quarter_nov: {
        id: 'iaso.label.periodType.quarter_nov',
        defaultMessage: 'Quarter Nov',
    },
    month: {
        id: 'iaso.label.periodType.month',
        defaultMessage: 'Month',
    },
    six_month: {
        id: 'iaso.label.periodType.six_month',
        defaultMessage: 'Semester',
    },
    week: {
        id: 'iaso.label.periodType.week',
        defaultMessage: 'Week',
    }
});

export default MESSAGES;
